const storage = weex.requireModule('storage')
const modal = weex.requireModule('modal')

/**
 * 存储localStorage
 * @param key
 * @param value
 * @param duration Storage有效时间，单位：小时
 * @param set_time 是否设置时间
 * @returns promise
 */
const setStorage = (key, value, set_time = false, duration = 0) => {
  return new Promise((resolve, reject) => {
    if (!key) {
      reject('key is empty !')
      return
    } 
    try {
      if (typeof value !== 'string') {
        value = JSON.stringify(value)
      }
      if (set_time) {
        let date = new Date()
        if (duration > 0) {
          value += '&' + (date.getTime() + duration * 3600 * 1e3)
        } else {
          value += '&0'
        }
        value += '&' + date.getTime()
      }
      storage.setItem(key, value, (event) => {
        if(event.result === 'success') {
          // event.data 为undefined, 故返回完整的event
          resolve(event)
        } else {
          reject(event)
        }
      })
    } catch (error) {
      console.error(error)
      reject(error)
    }
    })
}
/**
 * 读取缓存
 * @param {string} key 缓存Key值
 * @param {boolean} parse 是否需要对缓存结果做解析
 * @returns promise
 */
const getStorage = (key, parse = false) => {
  return new Promise((resolve, reject) => {
    if(!key) {
      reject('key is empty !')
    }
    try {
      storage.getItem(key, event => {
        if (event.result === 'success') {
          if (parse) {
            try {
              let result = JSON.parse(event.data)
              resolve(result)
            } catch (error) {
              resolve(event.data)
            }
          } else {
            resolve(event.data)
          }
        } else {
          reject(`key: "${key}" not found`)
        }
      })
    } catch (error) {
      reject(error)
    }
    
  })
}

/**
 * 删除指定缓存
 * @param {string} key 缓存key值
 * @returns promise
 */
const removeStorage = key => {
  return new Promise((resolve, reject) => {
    try {
      if (!key) {
        reject('key is empty !')
      } else {
        storage.removeItem(key, event => {
          event.result === 'success' ? resolve(event) : reject(`remove key: "${key}" failed`)
        })
      }
    } catch (error) {
      console.error(error)
      reject(error)
    }
  })
}

const length = () => {
  return new Promise((resolve, reject) => {
    storage.length(event => {
      event.result === 'success' ? resolve(event.data) : reject('failed to get local storage length')
    })
  })
}

const getAllKeys = () => {
  return new Promise((resolve, reject) => {
    storage.getAllKeys(event => {
      let keyGroupStr = event.data.join(', ')
      event.result === 'success' ? resolve(`props:${keyGroupStr}`) : reject('get all keys failed')
    })
  })
}

export default {
  setStorage,
  getStorage,
  removeStorage,
  length,
  getAllKeys
}



// WEBPACK FOOTER //
// ./packages/core/storage.js